import CommissionsContainer from './CommissionsContainer';

export {
  CommissionsContainer
};

export default CommissionsContainer;
